import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import './crudParentChildTable.css'
import { Close } from '@mui/icons-material'
import { LoadingContext, BufferService, NavigateContext, M_Select, M_MessageBoard, M_Button, M_DrawerTableTextField, M_InputTextField, M_SimpleTable, M_TabsInpage } from '../../../M_Components'
import { getRenderer } from "../../../components/field-renderers"

export function CrudParentChildTable({ }) {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const operation = 'Create'
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()
    const sessionStorageInfo = sessionStorage.getItem('crudDoubleTable') ? JSON.parse(sessionStorage.getItem('crudDoubleTable')) : { parent: '', child: '', field: '' }
    sessionStorage.removeItem('crudDoubleTable')

    const [hasConfirmation, setHasConfirmation] = useState(sessionStorage.getItem('hasConfirmation') ? JSON.parse(sessionStorage.getItem('hasConfirmation')) : false)
    sessionStorage.removeItem('hasConfirmation')
    const [parentEntity, setParentEntity] = useState(sessionStorageInfo.parent)
    const [childEntity, setChildEntity] = useState(sessionStorageInfo.child)
    const [entityField, setEntityField] = useState(sessionStorageInfo.field)
    const [parentFields, setParentFields] = useState([])
    const [childFields, setChildFields] = useState([])
    const [tab, setTab] = useState('Parent')
    const [valueMap, setValueMap] = useState(new Map())
    const [childMap, setChildMap] = useState(new Map())
    const [childObj, setChildObj] = useState([])
    const [companies, setCompanies] = useState([])
    const [isFirst, setIsFirst] = useState(true)

    const parentService = new BufferService(parentEntity)
    const childService = new BufferService(childEntity)

    const validateService = new BufferService(`${parentEntity}/validate`)

    const [openMessage, setOpenMessage] = useState(false)
    const [message, setMessage] = useState('')


    useEffect(() => {
        if (isFirst) {
            getSessionStorageData(id)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
            setIsFirst()
        }
    }, [])

    const sessionKeys = ['parentEntity', 'childEntity', 'entityField', 'parentFields', 'childFields', 'tab', 'valueMap', 'childMap', 'childObj', 'companies', 'hasConfirmation']

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {

        const tempPE = JSON.parse(sessionStorage.getItem(`${sessionID}parentEntity`))
        const tempCE = JSON.parse(sessionStorage.getItem(`${sessionID}childEntity`))
        const tempEF = JSON.parse(sessionStorage.getItem(`${sessionID}entityField`))
        const tempPF = JSON.parse(sessionStorage.getItem(`${sessionID}parentFields`))
        const tempCF = JSON.parse(sessionStorage.getItem(`${sessionID}childFields`))
        const tempT = JSON.parse(sessionStorage.getItem(`${sessionID}tab`))
        const tempVM = JSON.parse(sessionStorage.getItem(`${sessionID}valueMap`))
        const tempCM = JSON.parse(sessionStorage.getItem(`${sessionID}childMap`))
        const tempCO = JSON.parse(sessionStorage.getItem(`${sessionID}childObj`))
        const tempC = JSON.parse(sessionStorage.getItem(`${sessionID}companies`))
        const tempHC = JSON.parse(sessionStorage.getItem(`${sessionID}hasConfirmation`))

        if (tempPE || tempCE || tempEF || tempPF || tempCF || tempT || tempVM || tempCM || tempCO || tempC || tempHC) {
            setParentEntity(tempPE)
            setChildEntity(tempCE)
            setEntityField(tempEF)
            setParentFields(tempPF)
            setChildFields(tempCF)
            setTab(tempT)
            setValueMap(new Map(tempVM))
            setChildMap(new Map(tempCM))
            setChildObj(tempCO)
            setCompanies(tempC)
            setHasConfirmation(tempHC)
            return
        }
        get()
    }

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [parentEntity, childEntity, entityField, parentFields, childFields, tab, valueMap, childMap, childObj, companies, hasConfirmation])

    const get = () => {

        if (operation === 'Create') {
            parentService.options().then((data) => {
                const tempMap = new Map()
                const tempParentArray = []
                data.forEach(i => {
                    if (!i.IsHiddenEdit) {
                        tempParentArray.push(i)
                        tempMap.set(i.Name, '')
                    }
                })
                setParentFields(tempParentArray)

                childService.options().then((data) => {
                    const tempChildArray = []
                    data.forEach(i => {
                        if (!i.IsHiddenEdit) {
                            tempChildArray.push(i)
                            tempMap.set(i.Name, '')
                        }
                    })
                    setChildFields(tempChildArray)
                    const companies = JSON.parse(sessionStorage.getItem('companies'))

                    if (companies?.length == 1) {
                        valueMap.set('UserCompanyId', companies[0].Id)
                        valueMap.set('UserCompanyIdName', companies[0].Code)
                        setValueMap(new Map(valueMap))
                    }
                    console.log(companies)
                    setCompanies(companies.map((tempComp) => {
                        return { label: tempComp.Code, value: tempComp.Id }
                    }))
                })
            })
        }
    }

    const cleanUp = () => {
        refreshCrud()
        ctx2.closeTab(JSON.parse(id))
    }

    const refreshCrud = () => {
        parentFields.forEach(elemParent => {
            valueMap.set(elemParent.Name, '')
        })
        childFields.forEach(elemChild => {
            childMap.set(elemChild.Name, '')
        })
        setValueMap(new Map(valueMap))
        setChildMap(new Map(childMap))
        setChildObj([])
    }

    const submitValues = () => {
        ctx.setIsLoad(true)

        const parentObj = Object.fromEntries(valueMap)

        if (hasConfirmation) {
            validateService.post(parentObj).then(valData => {
                if (valData.name === 'AxiosError') {
                    if (Array.isArray(valData?.response?.data?.Errors)) {
                        ctx.toastMessages('error', valData?.response?.data?.Errors.toString(), 'Erro, ')
                    } else {
                        ctx.toastMessages('error', valData?.response?.data, 'Erro, ')
                    }
                    ctx.setIsLoad(false)
                    return
                }
                if (Object.keys(valData)[0] === 'NEEDS_VALIDATION') {
                    setMessage(Object.values(valData)[0])
                    setOpenMessage(true)
                    ctx.setIsLoad(false)
                }
                if (Object.keys(valData)[0] === 'CAN_CREATE') {
                    submitCall()
                }
                if (Object.keys(valData)[0] === 'CANT_CREATE') {
                    ctx.toastMessages('error', '', Object.values(valData)[0])
                    ctx.setIsLoad(false)
                }
            })
        } else {
            submitCall()
        }

    }

    const submitCall = () => {
        const parentObj = Object.fromEntries(valueMap)
        const childArray = childObj

        parentService.post(parentObj).then(data => {
            if (data.name === 'AxiosError') {
                if (Array.isArray(data?.response?.data?.Errors)) {
                    ctx.toastMessages('error', data?.response?.data?.Errors.toString(), 'Erro, ')
                } else {
                    ctx.toastMessages('error', data?.response?.data, 'Erro, ')
                }
                ctx.setIsLoad(false)
                return
            }
            if (childArray.length === 0) {

                const tempChil = Object.fromEntries(childMap)

                if (Object.values(childMap).length !== 0) {
                    tempChil[entityField] = data.Id
                    childService.post(tempChil).then(childData => {
                        if (childData.name === 'AxiosError') {
                            if (Array.isArray(childData?.response?.data?.Errors)) {
                                ctx.toastMessages('error', childData?.response?.data?.Errors.toString(), 'Erro, ')
                            } else {
                                ctx.toastMessages('error', childData?.response?.data, 'Erro, ')

                            }
                            ctx.setIsLoad(false)
                            return
                        }
                        ctx.setIsLoad(false)
                        ctx.toastMessages('success', '', t("AddSuccess"))
                        refreshCrud()
                        ctx2.closeTab(JSON.parse(id))
                    })
                } else {
                    ctx.setIsLoad(false)
                    ctx.toastMessages('success', '', t("AddSuccess"))
                    refreshCrud()
                    ctx2.closeTab(JSON.parse(id))
                }

            } else {

                childArray.forEach(childElem => {
                    childElem[entityField] = data.Id
                    childService.post(childElem).then(childData => {
                        if (childData.name === 'AxiosError') {
                            if (Array.isArray(childData?.response?.data?.Errors)) {
                                ctx.toastMessages('error', childData?.response?.data?.Errors.toString(), 'Erro, ')
                            } else {
                                ctx.toastMessages('error', childData?.response?.data, 'Erro, ')

                            }
                            ctx.setIsLoad(false)
                            return
                        } else {
                            ctx.setIsLoad(false)
                            ctx.toastMessages('success', '', t("AddSuccess"))
                            refreshCrud()
                            ctx2.closeTab(JSON.parse(id))
                        }
                    })
                })
            }
        })
    }

    const addValue = (value, code, map, setMap) => {
        map.set(code, value)
        setMap(new Map(map))
    }

    const addChildTable = () => {
        const tempObj = Object.fromEntries(childMap)

        childFields.forEach(fields => {
            childMap.set(fields.Name, '')
        })
        if (childObj.length) {
            const newId = childObj[childObj.length - 1].Id
            tempObj.Id = newId + 1
        } else {
            tempObj.Id = 1
        }
        setChildObj(prev => [...prev, tempObj])
        setChildMap(new Map(childMap))

    }

    const editTable = (data, value, code) => {
        let tempObj = data
        tempObj[code] = value
        setChildObj(childObj.map(obj => {
            if (obj.Id === data.Id) {
                return tempObj
            }
            else return obj
        }))
    }

    const deleteRow = (value) => {
        const tempArray = childObj.filter(elem => elem.Id !== value.Id)
        setChildObj(tempArray)
    }

    const tableColumns = () => {
        const tempColumns = childFields.map((tableElem, index) => {
            return {
                id: index,
                header: tableElem.NormalizedName,
                field: tableElem.Name,
                body: tableElem.Type === 'string' ?
                    (tableValue) => <M_InputTextField maxNumbers={tableElem.MaxLen} color={'var(--color-white)'} value={tableValue[tableElem.Name]} onChange={(e) => editTable(tableValue, e.target.value, tableElem.Name)} />
                    : tableElem.Type === 'int32' ?
                        (tableValue) => <M_InputTextField maxNumbers={tableElem.MaxLen} type={'int32'} color={'var(--color-white)'} value={tableValue[tableElem.Name]} onChange={(e) => editTable(tableValue, e.target.value, tableElem.Name)} />
                        : (tableValue) => tableValue[tableElem.Name] || ''
            }
        })
        tempColumns.push({
            bodyStyle: { maxWidth: '50px' },
            // body: (data) => <Close className='cursorPointer' onClick={() => deleteRow(data)} />
            body: (data) => <M_Button none icon={<Close style={{ color: 'var(--color-red)' }} />} onClick={() => deleteRow(data)
            } />
        })
        return tempColumns
    }

    const drawerValue = (data) => {
        if (valueMap.get(data.ForeignTableToPassId)) {
            let tempObj = {}
            tempObj.Id = valueMap.get(data.ForeignTableToPassId)
            tempObj[data.ForeignKeyName] = valueMap.get(data.Name)
            return tempObj
        } else {
            return null
        }
    }


    return (
        <div style={{ backgroundColor: 'var(--color-white)', position: 'sticky', top: '250px' }}>
            <div style={{ borderBottom: '1px solid var(--color-grey)', backgroundColor: 'var(--color-white)', width: '100%', display: 'flex', height: '45px', alignItems: 'center', padding: '5px' }}>
                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', left: '0', height: '35px' }}>
                    <M_Button
                        tooltip={t("Close")}
                        label={t("Close")}
                        icon={<i className="pi pi-arrow-left iconTable" style={{ color: ctx.secondaryColor }}></i>}
                        onClick={() => cleanUp()}
                    />
                    <M_Button
                        tooltip={t("RefreshTable")}
                        label={operation === 'Create' ? t("Reset") : t("Refresh")}
                        icon={<i className="pi pi-refresh iconTable"></i>}
                        onClick={() => refreshCrud()}
                    />
                    {operation === 'Create' || operation === 'Copy' ?
                        <M_Button
                            tooltip={t("Save")}
                            label={t("Save")}
                            icon={<i className="pi pi-save iconTable"></i>}
                            onClick={() => { if (operation === 'Create' || operation === 'Copy') submitValues() }}
                        />
                        : ''
                    }
                </div>
            </div >
            <div >
                <M_TabsInpage
                    type={'buttons'}
                    renderTabs={[
                        { labelTab: parentEntity, Code: 'Parent' },
                        { labelTab: childEntity, Code: 'Child' }
                    ]}
                    onGetTab={(obj) => setTab(obj.Code)}
                />

                {tab === 'Parent' && <div id='PARENT'>
                    <div style={{ justifyContent: 'inherit', display: 'grid', gridTemplateColumns: 'auto auto auto auto', paddingTop: '20px' }} >
                        {parentFields.map((data, index) => {
                            const Renderer = getRenderer(parentEntity, data);
                            return (
                            <div key={index} style={{ width: '100%', padding: '20px 40px 0px 40px' }}>
                                {data.Name === 'UserCompanyId' ?
                                    <M_Select
                                        autocomplete
                                        label={'User Company'}
                                        value={valueMap.get('UserCompanyId') ?
                                            {
                                                label: valueMap.get('UserCompanyIdName'),
                                                value: valueMap.get('UserCompanyId')
                                            } : null
                                        }
                                        options={companies}
                                        color={!valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        secondColor={!valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        required={true}
                                        onChangeValue={(value) => {
                                            if (value) {
                                                addValue(value.label, 'UserCompanyIdName', valueMap, setValueMap)
                                                addValue(value.value, 'UserCompanyId', valueMap, setValueMap)
                                            } else {
                                                addValue('', 'UserCompanyIdName', valueMap, setValueMap)
                                                addValue('', 'UserCompanyId', valueMap, setValueMap)
                                            }
                                        }}
                                        onChange={(e) => {
                                            addValue(e.target.value, data.Name, valueMap, setValueMap)
                                        }}
                                    />
                                    : data.IsForeignKey ?
                                        <M_DrawerTableTextField
                                            tableLabel={data.ForeignTableName}
                                            label={data.NormalizedName}
                                            value={drawerValue(data)}
                                            entity={data.ForeignTableName}
                                            filterField={data.ForeignKeyName}
                                            labelFields={[data.ForeignKeyName] || []}
                                            required={data.IsRequired}
                                            color={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            secondColor={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            onSubmitValue={(obj) => {
                                                if (obj) {
                                                    addValue(obj.Id, data.ForeignTableToPassId, valueMap, setValueMap)
                                                    addValue(obj[data.ForeignKeyName], data.Name, valueMap, setValueMap)
                                                } else {
                                                    addValue('', data.ForeignTableToPassId, valueMap, setValueMap)
                                                    addValue('', data.Name, valueMap, setValueMap)
                                                }
                                            }}

                                        // onSaveId={(e) => addValue(e, data.ForeignTableToPassId, valueMap, setValueMap)}
                                        // onExtraFields={(e) => {
                                        //     addValue(e.get(data.ForeignKeyName), data.Name, valueMap, setValueMap)
                                        // }}
                                        />
                                        :data.Name === 'OfficePhone' ?
                                        <Renderer
                                            name={data.Name}
                                            label={data.NormalizedName}
                                            map={valueMap}
                                            setMap={setValueMap}
                                            required={!!data.IsRequired}
                                            maxNumbers={9}
                                            minNumbers={Math.max(4, data.MinLen || 4)}
                                            disableNumberUntilPrefix={true}
                                            type={data.Type}
                                            value={valueMap.get(data.Name) || ''}
                                            onChange={(e) => addValue(e.target.value, data.Name, valueMap, setValueMap)}
                                            color={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            secondColor={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        />
                                        :
                                        <M_InputTextField
                                            label={data.NormalizedName}
                                            type={data.Type}
                                            value={valueMap.get(data.Name) || ''}
                                            onChange={(e) => addValue(e.target.value, data.Name, valueMap, setValueMap)}
                                            required={data.IsRequired}
                                            color={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            secondColor={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        />
                                }
                            </div>
                        )})}
                    </div>
                </div>}
                {tab === 'Child' && <div id='CHILD'>
                    <div style={{ justifyContent: 'inherit', display: 'grid', gridTemplateColumns: 'auto auto auto auto', paddingTop: '20px' }} >
                        {childFields.map((data, index) => (
                            <div key={index} style={{ width: '100%', padding: '20px 40px 0px 40px' }}>
                                <M_InputTextField
                                    maxNumbers={data.MaxLen}
                                    label={data.NormalizedName}
                                    value={childMap.get(data.Name) || ''}
                                    required={data.IsRequired}
                                    type={data.Type}
                                    color={data.IsRequired && !childMap.get(data.Name) ? 'var(--color-red)' : ''}
                                    secondColor={data.IsRequired && !childMap.get(data.Name) ? 'var(--color-red)' : ''}
                                    onChange={(e) => addValue(e.target.value, data.Name, childMap, setChildMap)}
                                />
                            </div>
                        ))
                        }
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', margin: '0px 40px 10px 40px', paddingBottom: '10px', borderBottom: '1px solid var(--color-grey)' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={'Add'}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => { addChildTable() }}
                        />
                    </div>
                    <div style={{ margin: '0px 20px' }}>
                        <M_SimpleTable
                            rows={childObj}
                            columns={tableColumns()}
                        />
                        {/* <DataTable value={childObj} size={'small'} >
                            {childFields.map((tableElem, index) => (
                                <Column key={index} field={tableElem.Name} header={tableElem.NormalizedName} body={(tableValue) => {
                                    if (tableElem.Type === 'string') {
                                        return <InputText
                                            className="p-inputtext-sm"
                                            style={{ borderColor: 'var(--color-white)' }}
                                            value={tableValue[tableElem.Name]}
                                            onChange={(e) => editTable(tableValue, e.target.value, tableElem.Name)}
                                        />
                                    } else
                                        if (tableElem.Type === 'int32') {
                                            <InputNumber
                                                className="p-inputtext-sm"
                                                style={{ borderColor: 'var(--color-white)' }}
                                                value={tableValue[tableElem.Name]}
                                                onChange={(e) => editTable(tableValue, e.target.value, tableElem.Name)}
                                            />
                                        } else {
                                            return <div>{tableValue[tableElem.Name] || ''}</div>
                                        }
                                }} />
                            ))}
                            <Column style={{ maxWidth: '50px' }} body={(data) => {
                                return <Close className='cursorPointer' onClick={() => deleteRow(data)} />
                            }} />

                        </DataTable> */}

                    </div>
                </div>}
            </div>
            <br /><br /><br /><br /><br />
            <M_MessageBoard
                open={openMessage}
                onClose={() => setOpenMessage(false)}
                title={'Confirmation Message'}
                body={message}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonConfirm')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setOpenMessage(false)
                                submitCall()
                            }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonCancel')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenMessage(false)}
                        />
                    </div>
                }
            />
        </div>
    )
}

